import { useAppSelector } from 'hooks/useAppSelector';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import { selectEssentialsFormQuoteResult } from 'routes/essential-workspace/state/form.selectors';
import { FormIdProps } from 'shared/props';
import { FormFieldId } from 'state/formData';
import { selectFieldIdValue } from 'state/selectors';

export function SolveFor({ formId }: FormIdProps) {
  const solveFor = useAppSelector(
    state => selectFieldIdValue(state, formId, 'SolvingMode' satisfies FormFieldId) as string | undefined,
  );
  const quoteResult = useAppSelector(state => selectEssentialsFormQuoteResult(state, formId));

  return (
    quoteResult !== undefined && (
      <span className="fs-6 text-secondary lh-1">
        <FormattedMessage id={`field.${solveFor}` as IntlKey} defaultMessage={solveFor} />
      </span>
    )
  );
}
